<div class="grid-container" (resized)="onResized($event)">
  <gridster [options]="options" *ngIf="gridItems.length>0">
    <gridster-item [item]="item" *ngFor="let item of gridItems; trackBy: trackBy" [id]="'gridItem' + item.id">
      <img *ngIf="isActiveDashboardEditable" src="assets/Img/resize-icon.svg" class="hover-icon-resize" />
      <i *ngIf="isActiveDashboardEditable" class="fal fal fa-edit icon-edit"
        [routerLink]="['/dashboard/wizard/',item.id]"></i>
      <i *ngIf="isActiveDashboardEditable" class="fal fa-trash-alt icon-remove" (click)="removeItem($event, item)"></i>
      <i *ngIf="(item.componentType == 3 || item.componentType == 4)  && statisticsPageAccess"
        class="fal fa-reply-all icon-go-to-reports" matTooltip="See on Reports page"
        [class.icon-go-to-reports-readonly]="!isActiveDashboardEditable" [routerLink]="['/reports']"
        [queryParams]="{ widgetId: item.id }"></i>
      <div class="widget">
        <h4>{{item.title}}
          <i *ngIf="restrictedDataWidgets.indexOf(item.id) > -1" class="fal fa-eye-slash restricted-data-partial-icon"
            title='{{"Restricted access. You don’t have a permission to view some of the items."| i18next}}'></i>
        </h4>
        <app-widget-container [gridItem]=item
          (restrictedDataEvent)="onRestrictedData($event,item)"></app-widget-container>
      </div>
    </gridster-item>
  </gridster>
</div>
<div *ngIf="gridItems.length == 0 && isActiveDashboardEditable && !clearDashboardRequested" class="empty-grid">
  <div class="inner-container">
    <div><i class="fal fa-chart-bar "></i></div>
    <span class="add-widget-text">{{ 'dashboard:Add widget' | i18next }}</span>
    <div class="add-widget-button">
      <span class="fa-stack" [routerLink]="['/dashboard/wizard/']" title="{{ 'dashboard:Add widget' | i18next }}">
        <i class="fa-stack-1x fas fa-circle"></i>
        <i class="fa-stack-2x fal fa-plus"></i>
      </span>
    </div>
  </div>
</div>
<div *ngIf="(gridItems.length == 0) && !isActiveDashboardEditable" class="empty-grid">
  <div class="inner-container">
    <div><i class="fal fa-analytics"></i></div>
    <span class="add-widget-text padding-15">{{ 'dashboard:This Dashboard is empty.' | i18next }}</span>
    <span class="add-widget-subtext padding-15">{{ 'dashboard:You do not have permissions to add widgets or edit it.' |
      i18next }}</span>
  </div>
</div>